module.exports = __webpack_public_path__ + "assets/77bbd75e88458e5303b84073be7e910a.svg";